import React from 'react';

import Register from './Register';

const RegisterPage = () => <Register />;

export default RegisterPage;
